import {
	API_ADMIN_GET_ALL_QUESTIONLIBRARY,
	API_ADMIN_DELETE_QUESTIONLIBRARY,
	API_ADMIN_GET_QUESTIONLIBRARY,
	API_ADMIN_PATCH_QUESTIONLIBRARY,
	ADMIN_INIT_NEW_QUESTIONLIBRARY,
	ADMIN_RESET_FOCUS_QUESTIONLIBRARY,
	API_ADMIN_POST_QUESTIONLIBRARY,
} from "../actions/questionLibrary";
import { DEFAULT_CLIENT, V2_CLIENT } from "config/clientConstants";

import {
	API_ADMIN_DELETE_MOTIVATIONLIBRARY,
	API_ADMIN_PATCH_MOTIVATIONLIBRARY,
	API_ADMIN_POST_MOTIVATIONLIBRARY,
	API_ADMIN_GET_ALL_MOTIVATIONSLIBRARY,
	API_ADMIN_GET_MOTIVATIONLIBRARY,
	ADMIN_RESET_FOCUS_MOTIVATIONLIBRARY,
	ADMIN_INIT_NEW_MOTIVATIONLIBRARY,
} from "../actions/motivationLibrary";
import {
	ADMIN_INIT_NEW_SYSTEMATICQUESTIONLIBRARY,
	ADMIN_RESET_FOCUS_SYSTEMATICQUESTIONLIBRARY,
	API_ADMIN_DELETE_SYSTEMATICQUESTIONLIBRARY,
	API_ADMIN_GET_ALL_SYSTEMATICQUESTIONLIBRARY,
	API_ADMIN_GET_SYSTEMATICQUESTIONLIBRARY,
	API_ADMIN_PATCH_SYSTEMATICQUESTIONLIBRARY,
	API_ADMIN_POST_SYSTEMATICQUESTIONLIBRARY,
} from "actions/systematicQuestionLibrary";

export const getVersion = (action) => {
	const path = pathMapping[action];
	return {
		path: path ? path[path.currentClient] : undefined,
		currentClient: path ? path.currentClient : DEFAULT_CLIENT,
	}
}

const pathMapping = {
	[API_ADMIN_GET_ALL_QUESTIONLIBRARY]: {
		default: "/admin/questionsLibrary",
		v2: "/questions-library",
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_GET_QUESTIONLIBRARY]: {
		default: (questionId) => `/admin/questionsLibrary/${questionId}`,
		v2: (questionId) => `/questions-library/${questionId}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_POST_QUESTIONLIBRARY]: {
		default: "/admin/questionsLibrary",
		v2: "/questions-library",
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_PATCH_QUESTIONLIBRARY]: {
		default: (questionId) => `/admin/questionsLibrary/${questionId}`,
		v2: (questionId) => `/questions-library/${questionId}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_DELETE_QUESTIONLIBRARY]: {
		default: (questionId) => `/admin/questionsLibrary/${questionId}`,
		v2: (questionId) => `/questions-library/${questionId}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_GET_ALL_SYSTEMATICQUESTIONLIBRARY]: {
		default: "/admin/questionsLibrary/systematic",
		v2: "/questions-library/systematic",
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_GET_SYSTEMATICQUESTIONLIBRARY]: {
		default: (questionId) => `/admin/questionsLibrary/${questionId}`,
		v2: (questionId) => `/questions-library/${questionId}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_POST_SYSTEMATICQUESTIONLIBRARY]: {
		default: "/admin/questionsLibrary",
		v2: "/questions-library",
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_PATCH_SYSTEMATICQUESTIONLIBRARY]: {
		default: (questionId) => `/admin/questionsLibrary/${questionId}`,
		v2: (questionId) => `/questions-library/${questionId}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_DELETE_SYSTEMATICQUESTIONLIBRARY]: {
		default: (questionId) => `/admin/questionsLibrary/${questionId}`,
		v2: (questionId) => `/questions-library/${questionId}`,
		currentClient: DEFAULT_CLIENT,
	},
};

export function adminGetQuestionLibrary(questionLibrary) {
	const version = getVersion(API_ADMIN_GET_QUESTIONLIBRARY);
	const url = typeof version.path === 'function' ? version.path(questionLibrary.id) : version.path;
	return {
		type: API_ADMIN_GET_QUESTIONLIBRARY,
		payload: {
			client: version.currentClient,
			request: {
				url,
			},
		},
	};
}
export function adminGetMotivationLibrary(questionLibrary) {
	return {
		type: API_ADMIN_GET_MOTIVATIONLIBRARY,
		payload: {
			request: {
				url: `/admin/motivationLibrary/${questionLibrary.id}`,
			},
		},
	};
}

export function adminGetQuestionSystematicLibrary(questionLibrary) {
	const version = getVersion(API_ADMIN_GET_SYSTEMATICQUESTIONLIBRARY);
	const url = typeof version.path === 'function' ? version.path(questionLibrary.id) : version.path;
	return {
		type: API_ADMIN_GET_SYSTEMATICQUESTIONLIBRARY,
		payload: {
			client: version.currentClient,
			request: {
				url,
			},
		},
	};
}

export function adminGetAllQuestionLibrary() {
	const version = getVersion(API_ADMIN_GET_ALL_QUESTIONLIBRARY);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_ADMIN_GET_ALL_QUESTIONLIBRARY,
		payload: {
			client: version.currentClient,
			request: {
				url,
			},
		},
	};
}

export function adminGetAllMotivationsLibrary() {
	return {
		type: API_ADMIN_GET_ALL_MOTIVATIONSLIBRARY,
		payload: {
			request: {
				url: `/admin/motivationsLibrary`,
			},
		},
	};
}

export function adminGetAllQuestionSystematicLibrary() {
	const version = getVersion(API_ADMIN_GET_ALL_SYSTEMATICQUESTIONLIBRARY);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_ADMIN_GET_ALL_SYSTEMATICQUESTIONLIBRARY,
		payload: {
			client: version.currentClient,
			request: {
				url,
			},
		},
	};
}

export function adminPostQuestionLibrary(questionLibrary) {
	const version = getVersion(API_ADMIN_POST_QUESTIONLIBRARY);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_ADMIN_POST_QUESTIONLIBRARY,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "POST",
				data: questionLibrary,
			},
		},
	};
}

export function adminPostQuestionSystematicLibrary(questionLibrary) {
	const version = getVersion(API_ADMIN_POST_SYSTEMATICQUESTIONLIBRARY);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_ADMIN_POST_SYSTEMATICQUESTIONLIBRARY,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "POST",
				data: questionLibrary,
			},
		},
	};
}

export function adminPatchQuestionLibrary(questionLibrary) {
	const version = getVersion(API_ADMIN_PATCH_QUESTIONLIBRARY);
	const url = typeof version.path === 'function' ? version.path(questionLibrary.id) : version.path;
	return {
		type: API_ADMIN_PATCH_QUESTIONLIBRARY,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "PATCH",
				data: questionLibrary,
			},
		},
	};
}

export function adminPatchQuestionSystematicLibrary(questionLibrary) {
	const version = getVersion(API_ADMIN_PATCH_SYSTEMATICQUESTIONLIBRARY);
	const url = typeof version.path === 'function' ? version.path(questionLibrary.id) : version.path;
	return {
		type: API_ADMIN_PATCH_SYSTEMATICQUESTIONLIBRARY,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "PATCH",
				data: questionLibrary,
			},
		},
	};
}

export function adminPostMotivationLibrary(motivationLibrary) {
	return {
		type: API_ADMIN_POST_MOTIVATIONLIBRARY,
		payload: {
			request: {
				url: `/admin/motivationsLibrary`,
				method: "POST",
				data: motivationLibrary,
			},
		},
	};
}
export function adminPatchMotivationLibrary(motivationLibrary) {
	return {
		type: API_ADMIN_PATCH_MOTIVATIONLIBRARY,
		payload: {
			request: {
				url: `/admin/motivationsLibrary/${motivationLibrary.id}`,
				method: "PATCH",
				data: motivationLibrary,
			},
		},
	};
}

export function adminDeleteMotivationLibrary(motivationLibrary) {
	return {
		type: API_ADMIN_DELETE_MOTIVATIONLIBRARY,
		payload: {
			request: {
				url: `/admin/motivationsLibrary/${motivationLibrary.id}`,
				method: "DELETE",
			},
		},
	};
}

export function adminDeleteQuestionLibrary(questionLibrary) {
	const version = getVersion(API_ADMIN_DELETE_QUESTIONLIBRARY);
	const url = typeof version.path === 'function' ? version.path(questionLibrary.id) : version.path;
	return {
		type: API_ADMIN_DELETE_QUESTIONLIBRARY,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "DELETE",
			},
		},
	};
}

export function adminDeleteQuestionSystematicLibrary(questionLibrary) {
	const version = getVersion(API_ADMIN_DELETE_SYSTEMATICQUESTIONLIBRARY);
	const url = typeof version.path === 'function' ? version.path(questionLibrary.id) : version.path;
	return {
		type: API_ADMIN_DELETE_SYSTEMATICQUESTIONLIBRARY,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "DELETE",
			},
		},
	};
}

export function initNewQuestionLibrary() {
	return {
		type: ADMIN_INIT_NEW_QUESTIONLIBRARY,
	};
}

export function resetFocusQuestionLibrary() {
	return {
		type: ADMIN_RESET_FOCUS_QUESTIONLIBRARY,
	};
}

export function initNewMotivationLibrary() {
	return {
		type: ADMIN_INIT_NEW_MOTIVATIONLIBRARY,
	};
}

export function resetFocusMotivationLibrary() {
	return {
		type: ADMIN_RESET_FOCUS_MOTIVATIONLIBRARY,
	};
}

export function initNewQuestionSystematicLibrary() {
	return {
		type: ADMIN_INIT_NEW_SYSTEMATICQUESTIONLIBRARY,
	};
}

export function resetFocusQuestionSystematicLibrary() {
	return {
		type: ADMIN_RESET_FOCUS_SYSTEMATICQUESTIONLIBRARY,
	};
}
